<template>
  <div
    id="scQuestionPage"
    v-if="superChallenge != null"
    :class="'popupPage anim' + (open ? ' open' : '')"
  >
    <div
      v-if="page == 'question' && question != null"
      class="questionPage container h-100"
    >
      <div class="row h-100">
        <div class="col-md-6 h-100 m-auto d-flex flex-column">
          <div
            class="header justify-content-center align-items-center mb-1 flex-column"
          >
            <div class="progress-holder mb-2">
              <progress-bar
                type="circle"
                ref="circle"
                :options="progressOptions"
                class="timer animate__animated animate__zoomIn animate__faster"
              ></progress-bar>
            </div>
            <span
              class="text-primary"
              v-html="
                $t('super_ch.question_time', { time: countDownTimerText })
              "
            ></span>
            <a
              @click.prevent="
                open = false;
                btnSfx();
              "
              href="#"
              class="close"
            ></a>
          </div>

          <div
            v-if="question.imageUrl != undefined"
            class="questionWithImage mb-3 w-100"
          >
            <div
              :class="
                'w-100 mb-3 d-flex justify-content-center align-items-center' +
                (showAnswers ? ' vh-20' : ' vh-40')
              "
            >
              <img
                :src="question.imageUrl"
                class="m-auto"
                @load="setImageLoaded"
              />
            </div>
            <h5 class="d-flex align-items-center mb-0">{{ question.text }}</h5>
          </div>
          <h3
            v-else
            @click="clickPrevent"
            class="noselect d-flex align-items-center justify-content-center vh-20 m-auto text-center"
          >
            {{ question.text }}
          </h3>

          <div
            v-if="showAnswers"
            class="text-center small text-warning vh-5 mb-3 mt-auto"
          >
            <span v-if="listItemClass == 'locked'">{{
              $t("super_ch.question_prevented_info2")
            }}</span>
          </div>

          <ul v-if="showAnswers" class="answers">
            <li
              @click="
                selectAnswer(a);
                btnSfx();
              "
              v-for="a in answersList"
              :key="a.id"
              :class="
                selectedId == a.id ? 'selected ' + selectedClass : listItemClass
              "
            >
              {{ a.text }}
              <i class="fas fa-check-circle"></i
              ><i class="fas fa-times-circle"></i>
            </li>
          </ul>
          <div v-else class="text-center small text-warning mb-3">
            {{ $t("super_ch.question_prevented_info1") }}
          </div>
          <div v-if="preventLock" class="preventLock">
            <div class="d-flex align-items-center noselect">
              <i class="text-danger fas fa-times-circle"></i>
              <span v-if="canAnswer">{{
                $t("super_ch.question_prevented_answer_text")
              }}</span>
              <span v-else>{{ $t("super_ch.question_prevented_text") }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else-if="page == 'rankPage'" class="rankPage h-100">
      <div class="container h-100">
        <div class="row h-100">
          <div class="col-md-6 h-100 m-auto d-flex flex-column">
            <div class="header mb-3">
              <h3 class="m-auto">{{ $t("super_ch.result_title") }}</h3>
              <a
                @click.prevent="
                  hide();
                  btnSfx();
                "
                href="#"
                class="close"
              ></a>
            </div>

            <div v-if="isWinner" class="resultsPageHeader winner">
              <img
                :src="
                  user.avatarUrl != undefined
                    ? user.avatarUrl
                    : '/images/male-default.png'
                "
                class="avatar"
              />
              <h4 class="text-orange mb-0">
                {{ $t("super_ch.result_win_title") }}
              </h4>
              <span class="text-primary">{{
                $t("super_ch.result_win_subtitle")
              }}</span>
              <span class="text-success"
                ><i class="fas fa-check-circle"></i> {{ answerTime }}</span
              >
              <div class="award">
                <div>{{ $t("super_ch.result_win_award_title") }}</div>
                <h3>{{ award != undefined ? award.abbr(true) : "0g" }}</h3>
              </div>
              <h5 class="text-primary">
                {{ $t("super_ch.result_win_other_users") }}
              </h5>
            </div>
            <div v-else class="resultsPageHeader">
              <img class="m-auto vh-15" src="/images/cup-tokens.png" />
              <h4 class="mb-3 text-orange">
                {{ $t("super_ch.result_info_title") }}
              </h4>
            </div>

            <ul :class="'participantsList' + (isWinner ? ' winner' : '')">
              <li
                v-for="w in participants.filter(
                  (d) => !(d.user.id == user.id && d.award > 0)
                )"
                :key="w.user.id"
              >
                <img
                  :src="
                    w.user.avatarUrl != undefined
                      ? w.user.avatarUrl
                      : '/images/male-default.png'
                  "
                />
                <div>
                  <h5 class="mb-1">{{ w.user.username }}</h5>
                  <div v-if="w.answerCorrect" class="small text-success">
                    <i class="fas fa-check-circle"></i>
                    {{ formatMicroTime(w.answerTime) }}
                  </div>
                  <div v-else class="small text-danger">
                    <i class="fas fa-times-circle"></i>
                  </div>
                </div>
                <span
                  ><img src="/images/token.png" />
                  <b>{{
                    w.award != undefined ? w.award.abbr(true) : "0g"
                  }}</b></span
                >
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <div
      v-else-if="page == 'interludePage' && interlude != null"
      class="interludePage h-100"
    >
      <div class="container h-100">
        <div class="row h-100">
          <div class="col-md-6 h-100 m-auto d-flex flex-column">
            <h3
              class="m-auto text-center animate__animated animate__fadeIn"
              v-html="interlude"
            ></h3>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Vue from "vue";
import api from "../api";
import { _ } from "vue-underscore";
import sha512 from "crypto-js/sha512";
import moment from "moment";

const SuperChallengeQuestion = Vue.component("super-challenge-question", {
  data() {
    return {
      open: false,
      page: "question",
      question: null,
      showAnswers: false,

      selectedId: null,
      canAnswer: false,
      imageLoaded: false,

      selectedClass: "",
      listItemClass: "locked",
      countDownTimerText: "-",

      preventCount: 0,
      preventInterval: 1,
      preventThreshold: 3,
      preventLock: false,

      interlude: null,

      isWinner: false,
      award: 0,
      answerTime: "-",
      participants: [],
      participantsPage: 1,
      participantsLoadingPage: false,
      allLoaded: false,

      progressOptions: {
        color: "#abccee",
        trailColor: "#7f3900",
        strokeWidth: 14,
        trailWidth: 14,
        from: { color: "#abccee" },
        to: { color: "#abccee" },
        step: function (state, circle, attachment) {
          circle.path.setAttribute("stroke", state.color);
        },
      },

      timeRoundingOptions: {
        TITHES: 1,
        HUNDREDTHS: 2,
        THOUSANDTHS: 3,
        TEN_THOUSANDTHS: 4,
      },
    };
  },

  stopwatch: 0,
  timer: null,
  offset: null,
  countDownTimer: null,
  preventTimer: 0,

  computed: {
    user() {
      return this.$store.state.auth.user;
    },
    superChallenge() {
      return this.$store.state.superChallenge.obj;
    },
    answersList() {
      return this.question != null ? _.shuffle(this.question.answers) : [];
    },
    networkTimeDiff() {
      return this.$store.state.config.networkTimeDiff;
    },
  },
  methods: {
    btnSfx() {
      this.$store.dispatch("sound/sfx", "Button");
    },

    replaceTags(str) {
      str = str.replace(
        /<link="(.*?)"  >(.*?)<\/link>/g,
        '<a target="_blank" href="$1">$2</a>'
      );
      str = str.replace(
        /<color="(.*?)">(.*?)<\/color>/g,
        '<span style="color:$1;">$2</color>'
      );
      str = str.replace(/\\u2022/g, "&#x2022 ");
      str = str.replace(/(?:\r\n|\r|\n)/g, "<br>");
      return str;
    },

    setInterlude(data) {
      this.open = true;
      this.interlude = this.replaceTags(data.text);
      this.page = "interludePage";
    },

    setEnd() {
      this.participantsAllLoaded = false;
      this.getParticipants(1);
    },

    getParticipants(page) {
      const $this = this;
      if (this.participantsAllLoaded || this.participantsLoadingPage) return;

      if (page == undefined) {
        page = this.participantsPage + 1;
      }

      this.participantsLoadingPage = true;
      api
        .superChallengeParticipants(this.superChallenge.id, page)
        .then((response) => {
          $this.participantsPage = page;
          $this.participants = $this.participants.concat(response.data);

          if (response.data.length == 0) $this.participantsAllLoaded = true;

          if (page == 1) {
            if (response.data.length == 0) {
              $this.$bvModal
                .msgBoxOk($this.$t("super_ch.no_results_text"), {
                  title: $this.$t("super_ch.no_results_title"),
                  size: "sm",
                  buttonSize: "lg",
                  okTitle: $this.$t("base.btn_ok"),
                  modalClass: "confirmModal",
                  hideHeaderClose: false,
                  centered: true,
                })
                .then((value) => {
                  $this.$store.dispatch("sound/sfx", "Button");
                });
              $this.hide();
            } else {
              $this.page = "rankPage";
              $this.$store.dispatch("sound/sfx", "Achievements");
              setTimeout(function () {
                const listElm = document.querySelector(".participantsList");
                listElm.addEventListener("scroll", (e) => {
                  let bottom =
                    Math.abs(
                      listElm.scrollHeight -
                        (listElm.scrollTop + listElm.clientHeight)
                    ) < 1;
                  if (bottom) {
                    $this.getParticipants();
                  }
                });
              }, 200);
            }

            $this.isWinner =
              response.data.length > 0 &&
              response.data[0].user.id == $this.user.id &&
              response.data[0].award > 0;
            if ($this.isWinner) {
              $this.award = response.data[0].award;
              $this.answerTime = $this.formatMicroTime(
                response.data[0].answerTime
              );
              $this.$store.dispatch("auth/getMe");
            }
          }
        })
        .catch((error) => {
          api.baseErrorHendler(error);
          $this.hide();
        })
        .then((r) => {
          $this.participantsLoadingPage = false;
        });
    },

    formatMicroTime(time) {
      return (
        (time / 1000000)
          .toFixed(12)
          .slice(
            0,
            this.timeRoundingOptions[this.superChallenge.answerTimeRounding] -
              12
          ) + "s"
      );
    },

    formatMilisecondTime(time) {
      return (
        (time / 1000)
          .toFixed(12)
          .slice(
            0,
            this.timeRoundingOptions[this.superChallenge.answerTimeRounding] -
              12
          ) + "s"
      );
    },

    clickPrevent() {
      if (this.preventLock) return;
      const $this = this;

      let netTime = moment.utc() + this.networkTimeDiff;
      let timeDiff = netTime - this.preventTimer;

      if (timeDiff / 1000 > this.preventInterval) {
        this.preventTimer = netTime;
        this.preventCount = 1;
      } else if (this.preventCount < this.preventThreshold) {
        this.preventCount++;
      } else {
        // stop player, potencial autobot...
        this.preventTimer = netTime;
        this.preventCount = 0;
        this.preventLock = true;
        //console.log('PREVENT CLICK');
        setTimeout(function () {
          $this.preventLock = false;
        }, moment
          .duration(this.superChallenge.cheatingBlockDuration)
          .valueOf());
      }
    },

    setQuestion(question) {
      const $this = this;
      this.open = true;
      this.page = "question";
      this.participants = [];
      this.question = question;
      this.canAnswer = false;
      this.showAnswers = false;
      this.selectedId = null;
      this.listItemClass = "locked";
      this.selectedClass = "";
      this.participantsLoadingPage = false;
      this.imageLoaded = false;
      // this.$store.dispatch('sound/bg','BG_TriviaQuiz');
      if (this.question.imageUrl == undefined)
        setTimeout(function () {
          $this.setTimer();
        }, 150);
    },

    setImageLoaded() {
      const $this = this;
      this.imageLoaded = true;
      setTimeout(function () {
        $this.setTimer();
      }, 30);
    },

    setTimer() {
      const $this = this;
      if (this.timer != null) {
        clearInterval(this.timer);
        this.timer = null;
      }

      this.offset = performance.now();
      this.stopwatch = 0;
      this.$refs.circle.setText("0s");
      this.$refs.circle.set(1);

      let sec = 0;
      let durationSec = moment.duration($this.question.timeout).seconds();
      let dt = moment.duration($this.question.timeout).valueOf();
      let qt = moment.duration($this.superChallenge.questionDuration).valueOf();
      let at = moment.duration($this.superChallenge.answerOffset).valueOf();

      // info timer
      this.countDownTimerText = durationSec + "s";
      this.countDownTimer = setInterval(() => {
        durationSec = durationSec - 1;
        $this.countDownTimerText = durationSec + "s";
        if (durationSec == 0) {
          clearInterval($this.countDownTimer);
          $this.countDownTimer = null;
        }
      }, 1000);

      // main timer
      this.timer = setInterval(() => {
        let now = performance.now(),
          d = now - $this.offset;

        $this.stopwatch = d;
        $this.$refs.circle.set((dt - $this.stopwatch) / dt);
        $this.$refs.circle.setText($this.formatMilisecondTime($this.stopwatch));

        // show answers
        if ($this.stopwatch >= qt) $this.showAnswers = true;

        if ($this.showAnswers && $this.stopwatch >= qt + at) {
          $this.canAnswer = true;
          $this.listItemClass = "";
        }

        if (
          dt - $this.stopwatch < 5000 &&
          $this.selectedId == null &&
          sec != (($this.stopwatch / 1000) | 0)
        )
          $this.$store.dispatch("sound/sfx", "Timer");

        sec = ($this.stopwatch / 1000) | 0;

        if ($this.stopwatch > dt) {
          clearInterval($this.timer);
          $this.timer = null;
          $this.canAnswer = false;
        }
      }, 1);
    },

    hide() {
      this.open = false;
      this.question = null;
      this.$store.dispatch("superChallenge/getChallenge");

      // clear timers
      if (this.countDownTimer != null) {
        clearInterval(this.countDownTimer);
        this.countDownTimer = null;
      }
      if (this.timer != null) {
        clearInterval(this.timer);
        this.timer = null;
      }
    },

    selectAnswer(answer) {
      this.clickPrevent();
      if (this.selectedId != null || !this.canAnswer || this.preventLock)
        return;

      const $this = this;
      let loader = document.getElementById("loader");
      loader.classList.add("show");

      this.selectedId = answer.id;

      if (this.timer != null) {
        // update timer before stop - this increase precission
        $this.stopwatch = performance.now() - $this.offset;

        clearInterval(this.timer);
        this.timer = null;
      }

      let dt = moment.duration($this.question.timeout).valueOf();

      $this.$refs.circle.set((dt - $this.stopwatch) / dt);
      $this.$refs.circle.setText($this.formatMilisecondTime($this.stopwatch));

      // console.log($this.stopwatch);
      let time = ($this.stopwatch * 1000) | 0;
      let key = sha512(
        time + "-!#2sdf$$%23kd(_H-9f9)!231kosd>mxcv!@!@#-" + this.user.id
      );

      api
        .superChallengeQuestionAnswer(
          this.superChallenge.id,
          this.selectedId,
          time,
          key.toString()
        )
        .then(function (response) {
          let data = response.data;
          // is answer correct ....
          $this.selectedClass = data.answer.correct ? "correct" : "wrong";
          // TODO - there you can add loading partipiants for super challenge if no events from socket.io // setTimeout(function(){  $this.showResults(data); }, 1500);
        })
        .catch(function (error) {
          //$this.selectedId = null;
          api.baseErrorHendler(error);
        })
        .then(function () {
          loader.classList.remove("show");
        });
    },
  },

  watch: {
    open() {
      document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
      document.body.scrollTop = 0; // For Safari
      if (this.open) document.body.classList.add("lock");
      else document.body.classList.remove("lock");
    },
  },

  beforeDestroy() {
    document.getElementById("loader").classList.remove("show");
  },
});

export default SuperChallengeQuestion;
</script>